import { RANDOM_DEFLATE_RATIO, QUALITY_REDUCE_RATIO } from './constants'

export const formatQualityScore = (
  qualityScore: number,
  baseRandomSeed: number
): number => {
  const reducedBasedScore = baseRandomSeed * RANDOM_DEFLATE_RATIO
  if (!qualityScore) {
    return reducedBasedScore
  }

  const reducedQualityScore = qualityScore * QUALITY_REDUCE_RATIO
  return reducedQualityScore + reducedBasedScore
}
